import { axiosInstance } from '../../../../Interceptors/axiosInterceptor';
import ApiUrlConstant from '../../../../Shared/Utils/UrlConstants';

const ReviewQueueService = {
  getAdminReports: (params) => {
    return axiosInstance.get(ApiUrlConstant.getAdminReports(), { params, loaderKey: 'getAdminReports' });
  },
  getAdminReportDetail: (id) => {
    return axiosInstance.get(ApiUrlConstant.updateAdminReport(id), { loaderKey: 'getAdminReportDetail' });
  },
  updateAdminReport: (id, data) => {
    return axiosInstance.put(ApiUrlConstant.updateAdminReport(id), data, { loaderKey: 'updateAdminReport' });
  },
  approveAdminReport: (id) => {
    return axiosInstance.post(ApiUrlConstant.approveAdminReport(id), {}, { loaderKey: 'approveAdminReport' });
  },
  regenerateAdminReport: (id) => {
    return axiosInstance.post(ApiUrlConstant.regenerateAdminReport(id), {}, { loaderKey: 'regenerateAdminReport' });
  },
  // Admin-edited portal copy, stored where impersonation edits go. '' clears a field.
  savePortalCopy: (id, edits) => {
    return axiosInstance.post(ApiUrlConstant.saveAdminReportPortalCopy(id), edits, { loaderKey: 'savePortalCopy' });
  },
  togglePortalLock: (patientId, portalLocked) => {
    return axiosInstance.post(ApiUrlConstant.togglePortalLock(patientId), { portal_locked: portalLocked }, { loaderKey: 'togglePortalLock' });
  },
};

export default ReviewQueueService;
